<div class="modal-header" id="calibration-date-modal-title">
    <h3 class="modal-title" id="modal-title" translate="CONFIRMATION_MEASUREMENT_TOOLS_CALLIBRATION_DATE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="row">
    <label class="col-3 col-form-label" translate="CONFIRMATION_MEASUREMENT_TOOLS_CALLIBRATION_DATE_ID"> </label>
    <div class="col-9 form-control-plaintext">{{ model.measurementToolId.value }}</div>
</div>
<div class="row">
    <label class="col-3 col-form-label" translate="CONFIRMATION_MEASUREMENT_TOOLS_CALLIBRATION_DATE_DESCRIPTION">
    </label>
    <div class="col-9 form-control-plaintext">{{ model.calibration.toolDescription }}</div>
</div>
<div class="row">
    <label class="col-3 col-form-label" translate="CONFIRMATION_MEASUREMENT_TOOLS_CALLIBRATION_DATE"> </label>
    <div class="col-9 form-control-plaintext">{{ model.calibration.calibrationDate }}</div>
</div>
<div class="modal-footer">
    <button class="btn btn-secondary" type="button" (click)="modalInstance.hide()" translate="MODAL_OK"></button>
</div>
